import { FC, ReactNode } from 'react';

import { ColumnCount, TableCell, TableHeader, TableRow, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    user: 'admin.Users.Header.user',
    account: 'admin.Users.Header.account',
    manager: 'admin.Users.Header.manager',
    actions: 'admin.Users.Header.actions',
};

interface UsersTableHeaderProps {
    hideActions?: boolean;
}

const TableCellHeader: FC<{ children: ReactNode; m: ColumnCount }> = ({ children, m }) => {
    return (
        <TableCell Element="th" m={m} align="left">
            <Text typography="label-3-regular" style="secondary">
                {children}
            </Text>
        </TableCell>
    );
};

export const UsersTableHeader: FC<UsersTableHeaderProps> = ({ hideActions = false }) => {
    const trl = useTrls();

    return (
        <TableHeader>
            <TableRow>
                <TableCellHeader m={hideActions ? 4 : 3}>{trl(TrlKeys.user)}</TableCellHeader>
                <TableCellHeader m={4}>{trl(TrlKeys.account)}</TableCellHeader>
                <TableCellHeader m={3}>{trl(TrlKeys.manager)}</TableCellHeader>
                {!hideActions && <TableCellHeader m={2}>{trl(TrlKeys.actions)}</TableCellHeader>}
            </TableRow>
        </TableHeader>
    );
};
